import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import translate from '../translate';

function BasicModal(props) {
  const {
    t,
    title,
    onClose,
    saveMessage,
    id,
    children,
    wrapperClass,
    data,
    ignoreCancelBtn,
    showCloseOnTop,
    cancelMessage,
    disabled,
    isLoading,
  } = props;

  const cancelText = cancelMessage || t('cancel');

  return (
    <Modal onClose={() => onClose(false, 'isCancel')} id={id}>
      <div
        className={`modal-dialog modal-dialog-centered modal-lg ${wrapperClass}`}
        role="document"
      >
        <div className="modal-content">
          {title ? (
            <ModalHeader
              title={title}
              onClose={
                showCloseOnTop && onClose
                  ? () => onClose(false, 'isCancel')
                  : undefined
              }
            />
          ) : null}
          {children ? <div className="modal-body">{children}</div> : null}
          <ModalFooter
            onSave={() => onClose(true, data)}
            cancelText={!ignoreCancelBtn ? cancelText : null}
            onCancel={() => onClose(false, data)}
            saveText={saveMessage}
            disabled={disabled}
            saveIsLoader={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
}

BasicModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.string,
  saveMessage: PropTypes.string.isRequired,
  children: PropTypes.node,
  title: PropTypes.string,
  wrapperClass: PropTypes.string,
  data: PropTypes.shape({}),
  ignoreCancelBtn: PropTypes.bool,
  showCloseOnTop: PropTypes.bool,
  cancelMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

BasicModal.defaultProps = {
  id: 'basicModal',
  title: null,
  children: null,
  wrapperClass: '',
  data: null,
  ignoreCancelBtn: false,
  showCloseOnTop: false,
  cancelMessage: null,
  isLoading: false,
  disabled: false,
};

export default translate(BasicModal);
